module.exports = __webpack_public_path__ + "static/livestorm-thumbnail1-35f7807d20f46cf6bf7a89b4d1ec37fc.gif";